















import { Component, Vue } from 'vue-property-decorator'
import BlockList from '../modules/BlockList.vue'
import AllowList from '../modules/AllowList.vue'

@Component({ components: { AllowList, BlockList } })
export default class SensitiveWordStock extends Vue {
  public activeKey = '1'
  public onChange(key) {
    this.activeKey = key
  }
}
